import { IonImg } from "@ionic/react";
import { FormattedMessage } from "react-intl";

import CardBase from "@components/cards/CardBase";
import styles from "@components/cards/HeroCard.module.css";
import BodyCopy from "@components/typography/BodyCopy";
import Heading2 from "@components/typography/Heading2";
import { imageUrl } from "@utils/imageUtils";

// This is slighty different from the other hero cards in that this has the card wrapper in addition to the content
const HeroCardWorkingOnIt = () => (
  <CardBase
    body={
      <div className={`${styles.wrapper} flex`}>
        <div className={`${styles.left} flex content-center items-center`} color="peach">
          {/* An empty string for alt text is WCAG approved for indicating that the image is decorative */}
          <IonImg alt="" src={imageUrl("isolationMode")} />
        </div>
        <div className={`${styles.right} flex flex-column text-center-lg-down`}>
          <div className="flex-grow" />
          <Heading2 bold={false} className="text-xl text-serif" color="primary">
            <FormattedMessage id="components.HeroCardWorkingOnIt.title" />
          </Heading2>
          <BodyCopy color="gray">
            <FormattedMessage id="components.HeroCardWorkingOnIt.subtitle" />
          </BodyCopy>
          <div className="flex-grow" />
        </div>
      </div>
    }
    bodyPadding={false}
    className={`${styles.heroCard} ion-no-margin`}
    color="white"
  />
);

export default HeroCardWorkingOnIt;
